import React from 'react';
import styles from './ActivityDateTable.module.scss';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, tooltipClick } from '@/components/TableCell';

const generateUUID = () => {
    let d = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
};

class ActivityDateTable extends React.Component {
    _columns = () => ([
        {
            title: '会员账号',
            dataIndex: 'tel',
            key: 'tel',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '领取时间',
            dataIndex: 'receiveTime',
            key: 'receiveTime',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '使用状态',
            dataIndex: 'couponUsableType',
            key: 'couponUsableType',
            align: 'center',
            width: '10%',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '订单编号',
            dataIndex: 'expendOrderId',
            key: 'expendOrderId',
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => this.expendOrder(text, record)
        }
    ]);

    // 解析表格数据，使符合columns格式要求
    _takeDataSource = (data) => {
        if (data) {
            return data.map(item => {
                item.key = generateUUID();
                return item;
            });
        }
    }

    expendOrder = (text, record) => {
        if (text == '0') return tooltip('');
        else {
            return tooltipClick(text, () => this.props.tableAction(record, 'expendOrderId'));
        }
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;

        return (
            <div className={styles.container}>
                <div className={styles.table_box}>
                    <Table
                        rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                        rowKey={(record) => record.key}
                        columns={this._columns()}
                        dataSource={this._takeDataSource(dataList)}
                        pagination={false}
                        scroll={{ y: 350 }}
                    />
                </div>
                <div className={styles.pagination_box}>
                    <XPagination
                        resultTotal={resultTotal}
                        pageSize={pageSize}
                        pageNum={pageNum}
                        onChange={paginationChange} />
                </div>
            </div>
        );
    }
}

ActivityDateTable.propTypes = {
    renderData: PropTypes.object, // 渲染数据源(双向绑定)
    tableAction: PropTypes.func, // 对表格的操作
    paginationChange: PropTypes.func
};

export default ActivityDateTable;